import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { toast } from 'vue3-toastify';

import capitalMarketsService from '../services/capitalMarketsService';
import type { AddToBlocklistRequest } from '../services/capitalMarketsService';

export default function useAddToBlocklist() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: AddToBlocklistRequest) => capitalMarketsService.addToBlocklist(payload),
    onError: (error: any) => {
      const errorMessage = error?.response?.data?.message || 'Erro ao adicionar financiamento à lista de bloqueios';
      toast.error(errorMessage);
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['financing-blocklist'] });
      toast.success(data.message || 'Financiamento adicionado à lista de bloqueios com sucesso');
    },
  });
}
